import '../styles/components/Footer.css'

export const Footer = () => {
    return (
        <footer>
            <div className="inside">
                <div>
                    <a href="https://github.com/chetpetro/leaderboard-website" target="_blank" rel="noreferrer">GitHub</a>
                    <a href="https://discord.gg/pnqrjdWF7R" target="_blank" rel="noreferrer">Pogostuck Discord</a>
                </div>
            </div>
        </footer>
    )
}